module.exports = {
  "country": "IS",
  "artist": "Hatari",
  "song": "Hatrio nun sigra",
  "year": "2019",
  "place": "10",
  "spotify": "1JBqLoGfH1LnGTE0wzAatU"
};